// extracted by mini-css-extract-plugin
export default {"icon":"PaymentProtectionBadge--icon--9f1f2f","link":"PaymentProtectionBadge--link--c79ef3"};